
export const LightGalleryLicence = "F0D72CBC-79BC-49BC-94E3-C91A1D286A73";

export const LocalStorageKeys = {
  AuthToken: 'AuthToken',
  IntendedUrl: 'IntendedUrl',
  DisplayUsers: 'DisplayUsers',
};

export const AppRoles = {
  admin: 'admin',
  manager: 'manager',
  user: 'user',
  guest: 'guest',
  groupManager: 'group-manager',
  groupUser: 'group-user',
};

export const AppRoleTypes = {
  global: 1,
  group: 2,
};

export const AppRoutes = {
  landing: {path: '/'},
  home: {path: '/domov'},
  login: {path: '/prihlasenie'},
  passwordRecovery: {path: '/obnova-hesla'},
  passwordChange: {path: '/zmena-hesla'},
  profile: {path: '/moj-ucet'},
  roles: {path: '/role'},
  notFound: {path: '/404'},
  users: {path: '/pouzivatelia'},
  userGroups: {path: '/pouzivatelske-skupiny'},
  representatives: {path: '/delegati'},
  buildingsPortfolio: {path: '/portfolio-nehnutelnosti'},
  buildings: {path: '/budovy'},
  managers: {path: '/spravcovia'},
  articles: {path: '/clanky'},
  buildingStats: {path: '/budovy-udaje'},
  buildingStatTypes: {path: '/budovy-typy-udajov'},
  attachmentCategories: {path: '/kategorie-dokumentov'},
  internalValues: {path: '/interna-hodnota'},
  membershipShares: {path: '/clenske-podiely'},
  transactions: {path: '/transakcie'},
  membership: {path: '/druzstvo'},
  membershipDocuments: {path: '/dokumenty-druzstva'},
  membershipGallery: {path: '/galeria-druzstva'},
};

export const AppEvents = {
  displayUsersChanged: 'displayUsersChanged',
};

export const ThemeColorMap = [
  '#2b45a9',
  '#737fed',
  '#6b5eae',
  '#ff679b',
  '#fa5c7c',
  '#e7791f',
  '#e3b52c',
  '#5ecb9b',
  '#099aa4',
  '#4bb2d0',
];

export const AttachmentTypes = {
  document: {val: 1, title: 'Dokument'},
  cover: {val: 2, title: 'Hlavné foto'},
  gallery: {val: 3, title: 'Galéria'},
  buildingMap: {val: 4, title: 'Mapa budovy'},
  membershipDocument: {val: 5, title: 'Dokumenty družstva'},
  membershipGallery: {val: 6, title: 'Galéria družstva'},
};

export const BuildingAttachmentTypes = {
  document: {val: 1, title: 'Dokument'},
  cover: {val: 2, title: 'Hlavné foto'},
  gallery: {val: 3, title: 'Galéria'},
  buildingMap: {val: 4, title: 'Mapa budovy'},
};

export const ArticleAttachmentTypes = {
  document: {val: 1, title: 'Dokument'},
  cover: {val: 2, title: 'Hlavné foto'},
  gallery: {val: 3, title: 'Galéria'},
};

export const UserAttachmentTypes = {
  document: {val: 1, title: 'Dokument'},
};

export const MembershipDocumentsAttachmentTypes = {
  membershipDocument: {val: 5, title: 'Dokumenty družstva'},
};

export const MembershipGalleryAttachmentTypes = {
  membershipGallery: {val: 6, title: 'Galéria družstva'},
};

export const AttachmentCategoryTypes = {
  user: {val: 1, title: 'Používateľ', color: 'success'},
  membership: {val: 2, title: 'Dokumenty družstva', color: 'indigo'},
  membershipGallery: {val: 3, title: 'Galéria družstva', color: 'dark'},
};

export const BuildingOwnershipTypes = {
  shares: {val: 1, title: 'Spoluvlastníctvo', color: 'success'},
  group: {val: 2, title: 'IH Družstvo', color: 'indigo'},
};

export const BuildingAccountingPeriodTypes = {
  quarterly: {val: 1, title: 'Kvartálne', color: 'success'},
  monthly: {val: 2, title: 'Mesačne', color: 'indigo'},
};

export const BuildingStatTypes = {
  rent: {             val: 2,     title: 'Nájom',                   metric: '€', description: ''},
  capacity: {         val: 213,   title: 'Obsadenosť',              metric: '%', description: 'Prenajaté'},
  capacityReserved: { val: 214,   title: 'Rezervovaná obsadenosť',  metric: '%', description: 'Rezervované'},
  capacityAccepted: { val: 220,   title: 'Akceptovaná obsadenosť',  metric: '%', description: 'Zazmluvnené'},
  capacityFree:     { val: 221,   title: 'Voľné',                   metric: '%', description: 'Voľné'},
  profit: {           val: 215,   title: 'Prevádzkový zisk FFO',    metric: '€', description: ''},
  lentArea: {         val: 216,   title: 'Prenajímaná plocha',      metric: 'm<sup>2</sup>', description: ''},
  parkingPlaces: {    val: 217,   title: 'Parkovacie miesta',       metric: '', description: ''},
  buildingValue: {    val: 218,   title: 'Hodnota nehnuteľnosti',   metric: '€', description: ''},
  repairFund: {       val: 219,   title: 'Fond opráv',              metric: '€', description: ''},
};

export const UserTypes = {
  person: {val: 1, title: 'Fyzická osoba'},
  company: {val: 2, title: 'Firma'}
};

export const ContactTypes = {
  email: {val: 1, title: 'Email'},
  tel: {val: 2, title: 'Tel'},
};

export const UserRepresentativeLink = {
  representative: {val: 1, title: 'Zástupca'},
  owner: {val: 2, title: 'Vlastník'},
  beneficiary: {val: 3, title: 'Konečný užívateľ výhod'},
};

export const UserRepresentativeMandate = {
  mandate: {val: 1, title: 'Plnomocenstvo'},
  guardian: {val: 2, title: 'Zákonný zástupca'},
  statutoryBody: {val: 3, title: 'Štatutárny orgán'},
};

export const AddressTypes = {
  default: {val: 1, title: 'Všeobecná'},
  residence: {val: 2, title: 'Sídlo'},
  correspondence: {val: 3, title: 'Korešpondenčná adresa'},
};

export const LocaleList = {
  sk: {val: 'sk', title: 'Slovensky'},
  en: {val: 'en', title: 'English'},
};

export const TransactionType = {
  credit: {val: 1, title: 'Vklad'},
  debet: {val: 2, title: 'Výber'},
};
